import React, { FunctionComponent, useEffect } from 'react';

import Layout from '../../containers/Layout';
import ImageTitle, { Icons } from '../../components/ImageTitle';
import { Content } from './styles';
import { useDefaultGtm } from '../../hooks/gtm/default/useDefaultGtm';

const BoletoExpired: FunctionComponent = () => {
  const { sendDataToGtm } = useDefaultGtm();

  useEffect(() => {
    sendDataToGtm({
      type: 'checkout',
      name: '/pagamento/infos-pagamento-error',
    });
    // eslint-disable-next-line
  }, []);

  return (
    <Layout dark>
      <ImageTitle
        data-cy='bank-slip'
        icon={Icons.boletoExpired}
        text="O boleto associado com esse CPF foi expirado e o pedido cancelado."
        primary
      />
      <Content data-cy='order-cancel-info'>
        Caso queira continuar com a compra, entre em contato com o vendedor para
        gerar um novo boleto.
      </Content>
    </Layout>
  );
};

export default BoletoExpired;
